import { render } from "./CounterpartyChangeDialog.vue?vue&type=template&id=13c2f21a&scoped=true&ts=true"
import script from "./CounterpartyChangeDialog.vue?vue&type=script&lang=ts"
export * from "./CounterpartyChangeDialog.vue?vue&type=script&lang=ts"

import "./CounterpartyChangeDialog.vue?vue&type=style&index=0&id=13c2f21a&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-13c2f21a"]])

export default __exports__
import QCard from 'quasar/src/components/card/QCard.js';
import QBtn from 'quasar/src/components/btn/QBtn.js';
import qInstall from "../../../../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'components', {QCard,QBtn});
